import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=688de5b2"
import script from "./UploadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports